import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPAAAA011, postPAIAE010DelChoice, postPAIAE010Choice, putPAAAA010ClickBanner } from '../services/Api';
import { getImageSrc, decodeToken } from '../utils';
import Loader from './components/Loader';
import Carousel from './components/Carousel';
import ImageCheckFallback from './components/ImageCheckFallback';
import { Link } from 'react-router-dom';
import { decodeHTML } from 'entities';

const RecruitLogoChecking = ({ folderName, imgName, src, alt, bizCompany }) => {
    const [hasError, setHasError] = useState(false);
    const handleError = () => setHasError(true);

    return imgName && !hasError ? (
        <img src={src || getImageSrc(folderName, imgName)} alt={alt || bizCompany || 'image'} onError={handleError} />
    ) : (
        <span style={{ fontSize: 20, fontWeight: 600, paddingTop: 20 }}>{bizCompany || '치과명없음'}</span>
    );
};

const BusinessHoverLogo = ({ folderName, imgName, src, alt, classImg }) => {
    const [hasError, setHasError] = useState(false);
    const transparentPixel = './images/default_logo.jpg';
    const handleError = () => setHasError(true);

    if (!imgName || hasError) {
        return <img className={classImg || ''} src={transparentPixel} alt="no image" />;
    }

    return <img className={classImg || ''} src={src || getImageSrc(folderName, imgName)} alt={alt || 'image'} onError={handleError} />;
};

const GrandBanner = () => {
    const [loading, setLoading] = useState(false);
    const [recruitBusiness, setRecruitBusiness] = useState([]);
    const [grandBanner, setGrandBanner] = useState([]);
    const [recruitGrand, setRecruitGrand] = useState([]);

    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login?.loggedIn;
    const token = useSelector(({ auth }) => auth.login?.token);
    const decode = decodeToken(token);

    useEffect(() => {
        setLoading(true);
        getPAAAA011()
            .then(({ data }) => {
                setGrandBanner(data ? data.grand || [] : []);
                setRecruitGrand(data ? data.recruitGrand || [] : []);
                setRecruitBusiness(data ? data.recruitBusiness || [] : []);
            })
            .catch((error) => console.log(error))
            .finally(() => setLoading(false));
    }, []);

    const removeStar = (item, setList) => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        }
        postPAIAE010DelChoice(item.choiceSeq)
            .then(() => {
                setList((prevList) =>
                    prevList.map((listItem) => (listItem.seq === item.seq ? { ...listItem, isChoice: 'N' } : listItem)),
                );
            })
            .catch((error) => console.log(error));
    };

    const activeStarRecruit = (item, setList) => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_C') {
            alert('개인회원만 이용가능합니다.');
            return;
        }
        postPAIAE010Choice({ tblName: 'Recruit', refSeq: item.seq, memberID: decode?.memberID })
            .then(({ data }) => {
                setList((prevList) =>
                    prevList.map((listItem) =>
                        listItem.seq === item.seq ? { ...listItem, isChoice: 'Y', choiceSeq: data.seq } : listItem,
                    ),
                );
            })
            .catch((error) => console.log(error));
    };

    return (
        <div id="grand-banner" style={{ backgroundColor: '#fff' }}>
            <div className="container">
                <div className="list-grid">
                    {grandBanner && grandBanner?.length > 0 && (
                        <div className="list-item list-item-1 slide GrandSlideBanner" style={{ height: '442px' }}>
                            <Carousel dataSlide={grandBanner} dataName="GrandSlide" />
                        </div>
                    )}
                    {recruitBusiness && recruitBusiness.length > 0 && (
                        <div
                            className={`list-item ${grandBanner?.length > 0 ? 'list-item-2' : 'list-item-1'
                                } large-full`}
                        >
                            <div className="item-content">
                                <div className="item-main-content">
                                    <div className="item-logo">
                                        <RecruitLogoChecking
                                            folderName={'recruit_logo'}
                                            imgName={recruitBusiness[0].logo}
                                            alt="logo recruitBusiness"
                                            bizCompany={recruitBusiness[0].bizCompany}
                                        />
                                    </div>
                                    <div className="item-desc">{recruitBusiness[0].title}</div>
                                    <div className="item-tag">
                                        {recruitBusiness[0].recruitClass &&
                                            recruitBusiness[0].recruitClass.includes(',')
                                            ? recruitBusiness[0].recruitClass.split(',')[0] + ' 외'
                                            : recruitBusiness[0].recruitClass}{' '}
                                        | {recruitBusiness[0].regionSi}({recruitBusiness[0].regionGu}) |{' '}
                                        {recruitBusiness[0].recruitForm &&
                                            recruitBusiness[0].recruitForm.includes(',')
                                            ? recruitBusiness[0].recruitForm.split(',')[0] + ' 외'
                                            : recruitBusiness[0].recruitForm}
                                    </div>
                                    <button
                                        className="bookmark"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            recruitBusiness[0].isChoice === 'Y'
                                                ? removeStar(recruitBusiness[0], setRecruitBusiness)
                                                : activeStarRecruit(recruitBusiness[0], setRecruitBusiness);
                                        }}
                                    >
                                        <i
                                            className={`icon icon-star ${recruitBusiness[0].isChoice === 'Y' ? 'active' : ''
                                                }`}
                                        />
                                    </button>
                                    <div className="item-image">
                                        <ImageCheckFallback
                                            folderName={'recruit_photo'}
                                            imgName={recruitBusiness[0]?.subBizImg?.split('|')[0]}
                                            alt="business banner"
                                        />
                                    </div>
                                </div>
                                <div className="item-hover-content">
                                    <Link
                                        to={`/paeaa070-${recruitBusiness[0].seq}?bs=${recruitBusiness[0].bannerSeq}`}
                                        className="content-banner-hover"
                                        style={{
                                            backgroundImage: `url(${getImageSrc(
                                                'recruit_photo',
                                                recruitBusiness[0]?.subBizImg?.split('|')[0],
                                            )})`,
                                        }}
                                    >
                                        <div className="content-banner-hover-logo">
                                            <RecruitLogoChecking
                                                folderName={'recruit_logo'}
                                                imgName={recruitBusiness[0].logo}
                                                alt="logo recruitBusiness"
                                                bizCompany={recruitBusiness[0].bizCompany}
                                            />
                                        </div>
                                        <div className="content-banner-hover-title">
                                            {recruitBusiness[0].bizCompany}
                                        </div>
                                        <div
                                            className="content-banner-hover-desc"
                                            to={`/paeaa070-${recruitBusiness[0].seq}?bs=${recruitBusiness[0].bannerSeq}`}
                                        >
                                            {recruitBusiness[0].title}
                                        </div>
                                    </Link>
                                    <button
                                        className="bookmark"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            recruitBusiness[0].isChoice === 'Y'
                                                ? removeStar(recruitBusiness[0], setRecruitBusiness)
                                                : activeStarRecruit(recruitBusiness[0], setRecruitBusiness);
                                        }}
                                    >
                                        <i
                                            className={`icon icon-star white ${recruitBusiness[0].isChoice === 'Y' ? 'active' : ''
                                                }`}
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {recruitBusiness && recruitBusiness.length > 1 && (
                        <div
                            className={`list-item ${grandBanner?.length > 0 ? 'list-item-3' : 'list-item-2'
                                } large-full`}
                        >
                            <div className="item-content">
                                <div className="item-main-content">
                                    <div className="item-logo">
                                        <RecruitLogoChecking
                                            folderName={'recruit_logo'}
                                            imgName={recruitBusiness[1].logo}
                                            alt="logo recruitBusiness"
                                            bizCompany={recruitBusiness[1].bizCompany}
                                        />
                                    </div>
                                    <div className="item-desc">{recruitBusiness[1].title}</div>
                                    <div className="item-tag">
                                        {recruitBusiness[1].recruitClass &&
                                            recruitBusiness[1].recruitClass.includes(',')
                                            ? recruitBusiness[1].recruitClass.split(',')[0] + ' 외'
                                            : recruitBusiness[1].recruitClass}{' '}
                                        | {recruitBusiness[1].regionSi}({recruitBusiness[1].regionGu}) |{' '}
                                        {recruitBusiness[1].recruitForm &&
                                            recruitBusiness[1].recruitForm.includes(',')
                                            ? recruitBusiness[1].recruitForm.split(',')[0] + ' 외'
                                            : recruitBusiness[1].recruitForm}
                                    </div>
                                    <button
                                        className="bookmark"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            recruitBusiness[1].isChoice === 'Y'
                                                ? removeStar(recruitBusiness[1], setRecruitBusiness)
                                                : activeStarRecruit(recruitBusiness[1], setRecruitBusiness);
                                        }}
                                    >
                                        <i
                                            className={`icon icon-star ${recruitBusiness[1].isChoice === 'Y' ? 'active' : ''
                                                }`}
                                        />
                                    </button>
                                    <div className="item-image">
                                        <ImageCheckFallback
                                            folderName={'recruit_photo'}
                                            imgName={recruitBusiness[1]?.subBizImg?.split('|')[0]}
                                            alt="business banner"
                                        />
                                    </div>
                                </div>
                                <div className="item-hover-content">
                                    <Link
                                        to={`/paeaa070-${recruitBusiness[1].seq}?bs=${recruitBusiness[1].bannerSeq}`}
                                        className="content-banner-hover"
                                        style={{
                                            backgroundImage: `url(${getImageSrc(
                                                'recruit_photo',
                                                recruitBusiness[1]?.subBizImg?.split('|')[0],
                                            )})`,
                                        }}
                                    >
                                        <div className="content-banner-hover-logo">
                                            <RecruitLogoChecking
                                                folderName={'recruit_logo'}
                                                imgName={recruitBusiness[1].logo}
                                                alt="logo recruitBusiness"
                                                bizCompany={recruitBusiness[1].bizCompany}
                                            />
                                        </div>
                                        <div className="content-banner-hover-title">
                                            {recruitBusiness[1].bizCompany}
                                        </div>
                                        <div
                                            className="content-banner-hover-desc"
                                            to={`/paeaa070-${recruitBusiness[1].seq}?bs=${recruitBusiness[1].bannerSeq}`}
                                        >
                                            {recruitBusiness[1].title}
                                        </div>
                                    </Link>
                                    <button
                                        className="bookmark"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            recruitBusiness[1].isChoice === 'Y'
                                                ? removeStar(recruitBusiness[1], setRecruitBusiness)
                                                : activeStarRecruit(recruitBusiness[1], setRecruitBusiness);
                                        }}
                                    >
                                        <i
                                            className={`icon icon-star white ${recruitBusiness[1].isChoice === 'Y' ? 'active' : ''
                                                }`}
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {recruitBusiness && recruitBusiness.length > 2 && (
                        <div
                            className={`list-item ${grandBanner?.length > 0 ? 'list-item-4' : 'list-item-3'
                                } large-full`}
                        >
                            <div className="item-content">
                                <div className="item-main-content">
                                    <div className="item-logo">
                                        <RecruitLogoChecking
                                            folderName={'recruit_logo'}
                                            imgName={recruitBusiness[2].logo}
                                            alt="logo recruitBusiness"
                                            bizCompany={recruitBusiness[2].bizCompany}
                                        />
                                    </div>
                                    <div className="item-desc">{recruitBusiness[2].title}</div>
                                    <div className="item-tag">
                                        {recruitBusiness[2].recruitClass &&
                                            recruitBusiness[2].recruitClass.includes(',')
                                            ? recruitBusiness[2].recruitClass.split(',')[0] + ' 외'
                                            : recruitBusiness[2].recruitClass}{' '}
                                        | {recruitBusiness[2].regionSi}({recruitBusiness[2].regionGu}) |{' '}
                                        {recruitBusiness[2].recruitForm &&
                                            recruitBusiness[2].recruitForm.includes(',')
                                            ? recruitBusiness[2].recruitForm.split(',')[0] + ' 외'
                                            : recruitBusiness[2].recruitForm}
                                    </div>
                                    <button
                                        className="bookmark"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            recruitBusiness[2].isChoice === 'Y'
                                                ? removeStar(recruitBusiness[2], setRecruitBusiness)
                                                : activeStarRecruit(recruitBusiness[2], setRecruitBusiness);
                                        }}
                                    >
                                        <i
                                            className={`icon icon-star ${recruitBusiness[2].isChoice === 'Y' ? 'active' : ''
                                                }`}
                                        />
                                    </button>
                                    <div className="item-image">
                                        <ImageCheckFallback
                                            folderName={'recruit_photo'}
                                            imgName={recruitBusiness[2]?.subBizImg?.split('|')[0]}
                                            alt="business banner"
                                        />
                                    </div>
                                </div>
                                <div className="item-hover-content">
                                    <Link
                                        to={`/paeaa070-${recruitBusiness[2].seq}?bs=${recruitBusiness[2].bannerSeq}`}
                                        className="content-banner-hover"
                                        style={{
                                            backgroundImage: `url(${getImageSrc(
                                                'recruit_photo',
                                                recruitBusiness[2]?.subBizImg?.split('|')[0],
                                            )})`,
                                        }}
                                    >
                                        <div className="content-banner-hover-logo">
                                            <BusinessHoverLogo
                                                folderName="recruit_logo"
                                                imgName={recruitBusiness[2].logo}
                                                alt="logo recruitBusiness"
                                                classImg="logo-img"
                                            />
                                        </div>


                                        <div className="content-banner-hover-title">
                                            {recruitBusiness[2].bizCompany}
                                        </div>
                                        <div
                                            className="content-banner-hover-desc"
                                            to={`/paeaa070-${recruitBusiness[2].seq}?bs=${recruitBusiness[2].bannerSeq}`}
                                        >
                                            {recruitBusiness[2].title}
                                        </div>
                                    </Link>
                                    <button
                                        className="bookmark"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            recruitBusiness[2].isChoice === 'Y'
                                                ? removeStar(recruitBusiness[2], setRecruitBusiness)
                                                : activeStarRecruit(recruitBusiness[2], setRecruitBusiness);
                                        }}
                                    >
                                        <i
                                            className={`icon icon-star white ${recruitBusiness[2].isChoice === 'Y' ? 'active' : ''
                                                }`}
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {recruitGrand && recruitGrand.length > 0 ? (
                        recruitGrand.map((item, index) => (
                            <div className="list-item-wrap" key={`grand-banner-2-${index}`}>
                                <div
                                    className={`list-item list-item-${5 + index} ${item.fixed !== 'Y' ? 'nor' : ''
                                        }`}
                                >
                                    {item.type === 'GRANDBANNER' ? (
                                        <div className="item-content">
                                            <div>
                                                <a
                                                    className="item-logo"
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    target="_blank"
                                                >
                                                    <RecruitLogoChecking
                                                        folderName={'recruit_logo'}
                                                        imgName={item.logo}
                                                        alt="logo recruit"
                                                        bizCompany={item.bizCompany}
                                                    />
                                                </a>
                                                <a
                                                    className="item-desc"
                                                    href={`/paeaa070-${item.seq}?bs=${item.bannerSeq}`}
                                                    target="_blank"
                                                >
                                                    {decodeHTML(item.title)}
                                                </a>
                                                <div className="item-tag">
                                                    {item.recruitClass && item.recruitClass.includes(',')
                                                        ? item.recruitClass.split(',')[0] + ' 외'
                                                        : item.recruitClass}{' '}
                                                    | {item.regionSi}({item.regionGu}) |{' '}
                                                    {item.recruitForm && item.recruitForm.includes(',')
                                                        ? item.recruitForm.split(',')[0] + ' 외'
                                                        : item.recruitForm}
                                                </div>
                                                <button
                                                    className="bookmark"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        item.isChoice === 'Y'
                                                            ? removeStar(item, setRecruitGrand)
                                                            : activeStarRecruit(item, setRecruitGrand);
                                                    }}
                                                >
                                                    <i
                                                        className={`icon icon-star ${item.isChoice === 'Y' ? 'active' : ''
                                                            }`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <a
                                            className="item-content"
                                            style={{ padding: '0px' }}
                                            href={
                                                item?.linkType === 'window'
                                                    ? item?.linkWinName
                                                    : item?.linkUrl
                                            }
                                            rel="nofollow"
                                            target={
                                                item?.linkType === 'window'
                                                    ? '_self'
                                                    : item?.linkType
                                            }
                                            onClick={async (e) => {
                                                if (item?.linkType !== '_blank') {
                                                    e.preventDefault();
                                                }
                                                await putPAAAA010ClickBanner(item?.seq);
                                                try {
                                                    if (item?.linkType === 'window') {
                                                        window.open(
                                                            item?.linkUrl,
                                                            '_blank',
                                                            'width=1200,height=1000',
                                                        );
                                                    } else if (item?.linkType !== '_blank') {
                                                        window.location.href = item?.linkUrl;
                                                    }
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            <ImageCheckFallback
                                                folderName={'banner_photo_grand'}
                                                imgName={item?.logo}
                                                alt="DentalJob"
                                                classImg="main-grandsub"
                                            />
                                        </a>
                                    )}


                                </div>
                            </div>
                        ))
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            {loading ? (
                <p className="center-loadding">
                    <Loader />
                </p>
            ) : (
                ''
            )}
        </div>
    );
};

export default GrandBanner;
